var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from '@/events/AppEvents';
import { Box, Center, FormControl, FormLabel, Icon, Input, Spinner, Text, Flex } from '@chakra-ui/react';
import { action, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { SketchPicker } from 'react-color';
import { FaFolder } from '@react-icons/all-files/fa/FaFolder';
import { BaseDialog, BaseDialogState } from './BaseDialog';
export class NewTagDialogState {
    constructor(createcb) {
        this.basedialogState = new BaseDialogState();
        this.name = "";
        this.creating = false;
        this.color = "";
        makeObservable(this);
        this.basedialogState.setDisableOkButton(true);
        this.basedialogState.setOkLabel("Create");
        this.basedialogState.setHeaderLabel("New Tag");
        this.basedialogState.onOk = () => this.createTag();
        this.createcb = createcb;
        APPEvent.addSubscriberForTagsResponse((res) => {
            if (this.creating) {
                this.setCreating(false);
                this.setOpen(false);
            }
        });
    }
    setColor(color) {
        this.color = color;
    }
    setName(name) {
        this.name = name;
        if (this.name) {
            this.basedialogState.setDisableOkButton(false);
        }
        else {
            this.basedialogState.setDisableOkButton(true);
        }
    }
    setCreating(creating) {
        this.creating = creating;
    }
    createTag() {
        if (!this.name.trim() || this.creating) {
            return;
        }
        this.setCreating(true);
        this.createcb(this.name, this.color);
    }
    setOpen(open) {
        this.basedialogState.setOpen(open);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], NewTagDialogState.prototype, "name", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], NewTagDialogState.prototype, "creating", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], NewTagDialogState.prototype, "color", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], NewTagDialogState.prototype, "setColor", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], NewTagDialogState.prototype, "setName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], NewTagDialogState.prototype, "setCreating", null);
let NewTagDialog = class NewTagDialog extends React.Component {
    constructor(prop) {
        super(prop);
    }
    buildBody() {
        return React.createElement(Box, null,
            React.createElement(FormControl, { id: "tagname", isRequired: true },
                React.createElement(FormLabel, null, "Tag Name"),
                React.createElement(Input, { id: 'tagname', placeholder: "Tag Name", value: this.props.state.name, onChange: (e) => this.props.state.setName(e.currentTarget.value) })),
            React.createElement(Flex, { mt: '10px' },
                React.createElement(Text, { mr: '10px', fontWeight: 'bold' }, "Folder Color: "),
                React.createElement(Box, null,
                    React.createElement(Icon, { as: FaFolder, color: this.props.state.color, w: '20px', h: '20px' }),
                    React.createElement(Box, { mt: '10px' },
                        React.createElement(SketchPicker, { color: this.props.state.color, onChange: ({ hex }) => this.props.state.setColor(hex) })))),
            this.props.state.creating && React.createElement(Box, { w: '100%', mt: '40px' },
                React.createElement(Center, null,
                    React.createElement(Spinner, null))));
    }
    render() {
        return React.createElement(BaseDialog, { state: this.props.state.basedialogState, body: this.buildBody() });
    }
};
NewTagDialog = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], NewTagDialog);
export { NewTagDialog };
